const TYPE_GOOGLE = 'google';

export { TYPE_GOOGLE };
